export default function formatDate (value) {
  // console.log('formatDate filter')
  if (value === undefined || value == null) { return '' }
  let returnVal = ''
  if (value !== null) {
    let date = Date
    date = new Date(value)
    returnVal = date.getDate().toString() + '-' + (date.getMonth() + 1).toString() + '-' + date.getFullYear().toString()
  }
  return returnVal
}
